import { default_header, default_header_example } from '../defaultData';
import { apiParamDesc, apiDocDesc } from '../docHelpers';

const getV11APIs = (userInfo) => {
  return [
    {
      title: '로그 조회',
      url: '/doc/로그 조회',
      data: [
        {
          version: 'v1.1',
          url: '/logs/v1.1',
          desc: apiDocDesc({
            items: [
              '주문, 상품정보의 로그를 조회합니다.',
              '로그 조회시 uniq, inq_uniq, prod_no, ol_shop_no 중의 하나의 호출정보는 반드시 입력해주셔야 합니다.',
            ],
          }),
          method: 'GET',
          header: default_header,
          header_example: default_header_example,
          query: [
            {
              title: 'uniq',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '주문 고유번호',
                sub: '(주문로그 검색인 경우 입력)',
              }),
            },
            {
              title: 'inq_uniq',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '문의 고유번호',
                sub: '(문의로그 검색인 경우 입력)',
              }),
            },
            {
              title: 'prod_no',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: 'SKU상품 고유번호',
                sub: '(SKU상품로그 검색인 경우 입력)',
              }),
            },
            {
              title: 'ol_shop_no',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '상품 고유번호',
                sub: '(상품로그 검색인 경우 입력)',
              }),
            },
            {
              title: 'sdate',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '검색시작일',
                sub: '(YYYY-MM-DD)',
              }),
            },
            {
              title: 'edate',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '검색종료일',
                sub: '(YYYY-MM-DD)',
              }),
            },
          ],
          response: [
            {
              title: 'results',
              required: 'O',
              type: 'Object',
              desc: '조회된 로그 리스트',
            },
            {
              title: 'wdate',
              required: 'O',
              type: 'String',
              desc: '등록일',
              indent: 1,
            },
            {
              title: 'name',
              required: 'O',
              type: 'String',
              desc: '작업자 이름',
              indent: 1,
            },
            {
              title: 'uniq',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '주문 고유번호',
                sub: '(주문로그 검색인 경우 출력)',
              }),
              indent: 1,
            },
            {
              title: 'inq_uniq',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '문의 고유번호',
                sub: '(문의로그 검색인 경우 출력)',
              }),
              indent: 1,
            },
            {
              title: 'prod_no',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: 'SKU상품 고유번호',
                sub: '(SKU 상품로그 검색인 경우 출력)',
              }),
              indent: 1,
            },
            {
              title: 'ol_shop_no',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '상품 고유번호',
                sub: '(상품로그 검색인 경우 출력)',
              }),
              indent: 1,
            },
            {
              title: 'content',
              required: 'O',
              type: 'String',
              desc: '작업내역',
              indent: 1,
            },
            {
              title: 'result',
              required: 'O',
              type: 'String',
              desc: '작업결과',
              indent: 1,
            },
          ],
          response_example: {
            results: [
              {
                wdate: '2022-07-19 13:45:46',
                name: '테스터',
                uniq: '3870764799502785130',
                content: '주문분할',
                result: '성공',
              },
              {
                wdate: '2022-07-08 11:31:46',
                name: '테스터',
                uniq: '3870764799502785130',
                content: '주문 상세정보 수정',
                result: '성공',
              },
              {
                wdate: '2022-07-08 11:31:46',
                name: '테스터',
                uniq: '3870764799502785130',
                content: '신규주문 수집',
                result: '성공',
              },
            ],
          },
        },
      ],
    },
  ];
};

export default getV11APIs;